import { KnownAction } from "../actions/marketing.actions";
import { IMarketingState } from "../models/marketing.interface";

const initialState: IMarketingState = {
  isCalendar: true,
};

function marketingReducer(
  state = initialState,
  action: KnownAction
): IMarketingState {
  switch (action.type) {
    case "SET_IS_CALENDAR": {
      return {
        ...state,
        isCalendar: action.swtch,
      };
    }
    default:
      return state;
  }
}

export default marketingReducer;
